import './footer.scss';

import React from 'react';
import classnames from 'classnames';
import { siteCodeSign } from 'js/sign-components/common/brand';

import AppFooter from 'hellosign/components/app/footer';

function CondorFooter({
  termsURL,
  privacyURL,
  condorFooter,
}) {
  return (
    <div className={classnames(condorFooter, 'condor-footer')}>
      <div className="container-fluid">
        <div className="row">
          <div className="col">
            <AppFooter
              termsURL={termsURL}
              privacyURL={privacyURL}
              siteCode={siteCodeSign} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CondorFooter;
